import { DateField, StateSelectField, TextField } from '@servicetitan/anvil2-react-hook-form';

interface StateIDFieldsProps {
    fieldPrefix?: string;
}

export const StateIDFields = ({ fieldPrefix = '' }: StateIDFieldsProps) => {
    return (
        <>
            <TextField
                label="ID Number"
                name={[fieldPrefix, 'applicantId.documentId'].join('.')}
                required
            />
            <DateField
                label="Issue Date"
                name={[fieldPrefix, 'applicantId.issueDate'].join('.')}
                required
            />
            <DateField
                label="Expiration Date"
                name={[fieldPrefix, 'applicantId.expirationDate'].join('.')}
                required
            />
            <StateSelectField
                label="State"
                name={[fieldPrefix, 'applicantId.state'].join('.')}
                required
            />
        </>
    );
};
